module.exports = __webpack_public_path__ + "static/Loading-Icons-ff5944887d944143d45bacabc298cce2.png";